/* eslint-disable */
import React from 'react';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import Button from 'src/onboarding/components/ui/button/Button';
import styles from './style.module.scss';
import phone1 from '../../assets/images/phoneBestApp1.png';
import phone2 from '../../assets/images/phoneBestApp2.png';
import rate from '../../assets/images/appStore.png';
import { ReactComponent as TimeSvg } from '../../assets/images/timeBestApp.svg';
import { ReactComponent as CosmostyleSvg } from '../../assets/images/cosmostyle.svg';
import { ReactComponent as RalsimpleSvg } from '../../assets/images/ralsimple.svg';
import { ReactComponent as ParadSvg } from '../../assets/images/parad.svg';
import { ReactComponent as PurewonSvg } from '../../assets/images/purewon.svg';
import { ReactComponent as PsSvg } from '../../assets/images/ps.svg';

function Page() {
  const { onNext, currentIndex } = useNav();
  const { showTwoPhones } = useRemoteConfig();

  const icons = [
    <TimeSvg />,
    <CosmostyleSvg />,
    <RalsimpleSvg />,
    <ParadSvg />,
    <PurewonSvg />,
    <PsSvg />,
  ];

  const duplicatedIcons = [...icons, ...icons];

  return (
    <div className={'layout'}>
      <div className={styles.wrapperInfo}>
        {showTwoPhones ? (
          <img src={phone2} className={styles.twoPhonesImage} alt='phone-image' />
        ) : (
          <img src={phone1} alt='phone-image' />
        )}
        <Title tag='h2' className={styles.title}>
          {t('onboarding.bestApp.title')}
        </Title>
      </div>

      <div className={styles.content}>
        <img src={rate} alt='app-store-rate' />

        <div className={styles.list}>
          <div className={styles.animationList}>{duplicatedIcons}</div>
        </div>
      </div>
      <div className={styles.continue}>
        <Button
          title={t('onboarding.bestApp.continue')}
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'best-app',
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
